//control components font sizes
export const multiplierFactor = 5.5
export const bustedFactor = 8
export const nextRoundFactor = 17